var _polygon, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5F00",
    points: "15.245 17.831 8.756 17.831 8.756 6.168 15.245 6.168 15.245 17.831"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M9.167,12c0-2.366,1.108-4.473,2.832-5.831c-1.306-1.029-2.92-1.588-4.583-1.586C3.32,4.583,0,7.904,0,12c0,4.096,3.32,7.417,7.416,7.417c1.663,0.003,3.278-0.556,4.584-1.586C10.275,16.474,9.167,14.366,9.167,12L9.167,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M24,12c0,4.096-3.32,7.417-7.416,7.417c-1.663,0.003-3.278-0.556-4.584-1.586c1.725-1.358,2.833-3.465,2.833-5.831S13.725,7.527,12,6.169c1.306-1.029,2.921-1.588,4.584-1.586C20.68,4.583,24,7.904,24,12L24,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE5300",
    d: "M14.833,12H9.167l0,0c0,2.366,1.108,4.473,2.833,5.831l0,0l0,0C13.725,16.473,14.833,14.366,14.833,12L14.833,12L14.833,12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD0018",
    d: "M9.167,12H0l0,0c0,4.096,3.32,7.417,7.416,7.417c0.004,0,0.008,0,0.012,0c1.659,0,3.27-0.558,4.573-1.586l0,0C10.275,16.474,9.167,14.366,9.167,12L9.167,12L9.167,12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D78A18",
    d: "M24,12h-9.167l0,0c0,2.366-1.108,4.473-2.833,5.831l0,0c1.303,1.027,2.913,1.586,4.573,1.586c0.004,0,0.008,0,0.012,0C20.68,19.417,24,16.096,24,12L24,12L24,12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.931661edb7d2ec3c90f59d7fd97e63cf.svg";
export { ForwardRef as ReactComponent };